module.exports = __webpack_public_path__ + "static/step_02.ce07a668.png";